import apiClient from '../apiClient';

class SupportService {
  async createCase(payload) {
    return apiClient.post('/support', payload);
  }

  async getMyCases() {
    return apiClient.get('/support/mine');
  }

  async addComment(caseId, comment) {
    return apiClient.post(`/support/${caseId}/comment`, { comment });
  }

  async updateStatus(caseId, status) {
    return apiClient.patch(`/support/${caseId}/status`, { status });
  }

  async reportProfile(payload) {
    return apiClient.post('/support/report', payload);
  }

  async uploadAttachments(caseId, files) {
    // files: [{ fileName, mimeType }]
    const result = await apiClient.post(`/support/${caseId}/attachments`, { files });
    return result; // { uploadUrls: [{ uploadUrl, s3Key, fileName }], supportCase }
  }
}

const supportService = new SupportService();
export default supportService;
